import { Component, OnInit, Input } from '@angular/core';
import { EmployeeService } from '../../../../employee.service';
import { NewEmployeeComponent } from '../../../../new-employee/new-employee.component';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  employees = [];
  reports = [];
  data: any = {
    report_origin: {
      internal: false,
      external: false,
    },
    report_type: {},
  };
  today = new Date();
  year = moment(this.today).format('YYYY')

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<ReportsComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id
    }
    await this.getReportsRequest()
    await this.getEmployees()
    await this.checkIfCreateOrEdit()
    this.loading = false
  }

  async getEmployees() {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
    console.log(this.employees);
  }

  async getReportsRequest() {
    const [err, result] = await this.sasisopaService.getReportRequests(this.stationId, this.year);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    console.log();
    this.reports = result;
  }

  async store() {
    this.data.date = moment(this.data.date).format('YYYY-MM-DD')
    this.data.station_id = this.stationId
    this.loading = true;
    const data = this.data
    if (typeof data.name_notifies === 'object') data.name_notifies = data.name_notifies.name_reports
    const [error, response] = await this.sasisopaService.createReports(data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato creado con éxito', 'success');
    this.ref.close(true);
  }

  async editFormat() {
    this.data.date = moment(this.data.date).format('YYYY-MM-DD')
    this.loading = true
    const data = this.data
    if (typeof data.name_notifies === 'object') data.name_notifies = data.name_notifies.name_reports
    const [error, response] = await this.sasisopaService.editReports(this.infoEdit.id, data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.date = moment(this.infoEdit.date).toDate()
      this.data.station_id = this.infoEdit.station_id
      this.data.number = this.infoEdit.number
      this.data.name_notifies = this.infoEdit.name_notifies
      this.data.response = this.infoEdit.response
      this.data.close_date = moment(this.infoEdit.close_date).toDate()
      this.data.name_follow_up = this.infoEdit.name_follow_up
      this.data.report_date = moment(this.infoEdit.report_date).toDate()
    }
  }

  onChange(e: any) {
    console.log('🚀 ~ file: reports.component.ts:121 ~ ReportsComponent ~ onChange ~ e:', e)
    // this.data.name_notifies = e.name_reports
    this.data.report_date = moment(e.notification_date).toDate()
    this.data.name_follow_up = e.name_follows_up
    console.log(e);
  }

}
